import React, {useEffect} from 'react';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { isLoggedIn, logout} from "../../features/user";
//import { setLoading} from "../../features/common";
import { useTranslation } from 'react-i18next';
import {checkValidToken, defaultPortalUrl} from "../../Helper"
import cookie from "js-cookie";

import Frame from '../widgets/Frame';

export function SuccessfullyLoggedIn() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const isUserLoggedIn = useSelector(isLoggedIn);

    /**
     * האם באמת יש לאן להעביר.
     *
     * `checkValidToken` מעביר ל-`redirect_from` או לממשק ברירת המחדל של הריסיילר, ואם
     * אין אף אחד מהם הוא נופל ל-`altForward` - שהוא **המסך הזה עצמו**. התוצאה היא מסך
     * שמבטיח "מייד תועברו" ונשאר עליו לנצח.
     *
     * המשפט נבחר לפי מה שקיים, כדי שלא נבטיח דבר שלא יקרה. זה אינו מתקן את היעדר
     * הכתובת - ריסיילר בלי ממשק ברירת מחדל הוא הגדרה חסרה בבילינג - אלא מפסיק לשקר
     * עליה.
     */
    const hasForwardTarget = Boolean(cookie.get("redirect_from") || defaultPortalUrl());

    useEffect(()=>{
        if(isUserLoggedIn) {
            checkValidToken(navigate, dispatch, logout, true, true, "/login");
        } else {
            navigate("/login");
        }
        /*if(isUserLoggedIn){
            if(searchParams.get("redirect")) {
                window.location.replace(searchParams.get("redirect"));
            }
        } else {
            navigate('/login');
        }*/
       // eslint-disable-next-line
    },[]);

    return (
            <Frame>
                <div className='main main-successfully-logged-in'>
                    <div className='main-top'>
                        <h1>{t("You've successfully logged in")}</h1>
                    </div>
                    <div className='main-body'>
                        <div className='right-main'>
                            <div className='right-main-inner'>
                                <h2>
                                    {hasForwardTarget
                                        ? t("You will be redirected to your account in a few seconds")
                                        : t("You can now close this window, or open your account from the address you came from")}
                                </h2>
                            </div>
                        </div>
                        <div className='left-main'>
                            <img src='/images/person-paper-plane.png' className='content-logo' alt=''/>
                        </div>
                    </div>
                </div>
            </Frame>
    );
}